import React from "react";

import { VStack } from "../../primitive";
import { RadioGroupContext, RadioGroupContextType } from "./RadioGroupContext";

export type RadioGroupProps = {
  value?: string;
  onChange?: (value: string) => void;
  isDisabled?: boolean;
  children: React.ReactNode;
  accessibilityLabel?: string;
  /** Set to false when the group contains interactive children that must remain independently accessible. */
  accessible?: boolean;
};

export const RadioGroup = ({
  value,
  onChange,
  isDisabled,
  children,
  accessibilityLabel,
  accessible,
}: RadioGroupProps) => {
  const contextValue: RadioGroupContextType = {
    value,
    onChange: onChange ?? (() => undefined),
    isDisabled,
  };

  return (
    <RadioGroupContext.Provider value={contextValue}>
      <VStack
        gap={3}
        accessible={accessible ?? accessibilityLabel != null}
        accessibilityLabel={accessibilityLabel}
        accessibilityRole="radiogroup"
      >
        {children}
      </VStack>
    </RadioGroupContext.Provider>
  );
};
